export default __webpack_public_path__ + "static/media/IIFL-Securities-Horizontal-PNG.642b3d01.png";